export const styles = {
  buttonResponsive: {
    "@media (max-width: 955px)": {
      width: "100%",
      marginLeft: "23px",
    },
  },
};
